export default "__VITE_ASSET__DQhs4YIp__"